import { jsx as r, jsxs as n } from "react/jsx-runtime";
import { V as i, s as l, S, a as s, C as m } from "./ScrollAreaScrollbar-CrHmfqax.js";
function p({
  children: o
}) {
  return /* @__PURE__ */ r(i, { className: l.scrollArea__viewport, children: o });
}
const u = ({
  children: o,
  vertical: e = !0,
  horizontal: a = !1,
  className: t,
  ...c
}) => /* @__PURE__ */ n(S, { ...c, className: t, children: [
  /* @__PURE__ */ r(p, { children: o }),
  e && /* @__PURE__ */ r(s, { orientation: "vertical" }),
  a && /* @__PURE__ */ r(s, { orientation: "horizontal" }),
  e && a && /* @__PURE__ */ r(m, { className: l.scrollArea__corner })
] });
export {
  u as S
};
